export function updateAccountInPath(oldPath: string, params: { accountCode: string; }) {
  let segments = oldPath.split("/");
  segments[1] = params.accountCode;
  let redirectUrl = segments.join("/");
  return redirectUrl;

}
